import { useQuery } from 'react-query';

import { getCardActivityTypes as queryFn } from 'api/endPoints/getCardActivity';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryKeys } from 'api/queryKeys';

import { ICardActivityCode } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryGetCardActivityTypes = (params: QueryParams) => {
    return useQuery<ICardActivityCode[], QueryError, ICardActivityCode[], [QueryKeys, unknown]>({
        queryKey: ['cardActivity', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
    });
};

export interface QueryParams {
    metaDataId?: IVersion['id'];
}
